export class Action {
  static readonly AUTHENTICATE = '/json/Authenticate';
  static readonly READ = '/json/Read';
  static readonly READ_CONFIGURATION = '/json/ConfigurationRead';
  static readonly READ_USER = '/json/UserRead';
  static readonly READ_FAMILY_TREE = '/json/FamilyTree';
  static readonly USER_UPDATE = '/json/UserUpdate';
  static readonly USER_CREATE = '/json/UserCreate';
  static readonly CREATE = '/json/Create';
  static readonly UPDATE = '/json/Update';
  static readonly DELETE = '/json/Delete';
  static readonly SESSION_INFO = '/json/GetSessionInfo';
  static readonly TOKEN_VALID = '/json/TokenValid';
  static readonly STATISTICS = '/json/GetStatistics';
  static readonly MAINTENANCE = '/json/Maintenance';
  static readonly VALIDATE = '/json/Validate';
  static readonly DuplicateCheck = '/json/DuplicateCheck';
  static readonly ATTACHMENTCREATE = '/json/AttachmentCreate';
  static readonly SYSTEM_INFO = '/json/GetSystemInfo';
  static readonly BINARY_DOWNLOAD = '/json/BinaryDownload';
  static readonly WorkflowStart = '/json/WorkflowStart';
  static readonly CancelWorkflow = '/json/CancelWorkflow';
  static readonly GET_CURRENT_USER_VIEW = '/json/GetCurrentUserView';
  static readonly SET_CURRENT_USER_VIEW = '/json/SetCurrentUserView';
  static readonly GET_EXCHANGE_CONSENT = '/json/GetExchangeConsent';
  static readonly SET_EXCHANGE_CONSENT = '/json/SetExchangeConsent';
}

export enum ActionType {
  Create = 'create',
  Delete = 'delete',
  Read = 'read',
  Update = 'update',
}
